export const STORAGE_KEYS = {
  policies: 'hx_policies',
  goals: 'hx_gap_goals',
  adjustments: 'hx_gap_adjustments',
  aiReportLatest: 'hx_ai_report_latest',
  aiCacheIndex: 'hx_ai_report_cache_index_v3',
  noteCacheIndex: 'hx_ai_note_cache_index_v2',
}

let storageErrorHandler = null

export const setStorageErrorHandler = (handler) => {
  storageErrorHandler = handler
}

const reportError = (error, operation, key) => {
  storageErrorHandler?.({ error, operation, key })
}

export const storage = {
  get(key, fallback = '') {
    try {
      return localStorage.getItem(key) ?? fallback
    } catch (error) {
      reportError(error, 'read', key)
      return fallback
    }
  },
  set(key, value) {
    try {
      localStorage.setItem(key, value)
      return true
    } catch (error) {
      reportError(error, 'write', key)
      return false
    }
  },
  remove(key) {
    try {
      localStorage.removeItem(key)
      return true
    } catch (error) {
      reportError(error, 'remove', key)
      return false
    }
  },
  json(key, fallback) {
    const raw = this.get(key)
    if (!raw) return fallback
    try {
      return JSON.parse(raw)
    } catch (error) {
      reportError(error, 'parse', key)
      return fallback
    }
  },
}

export const clearKeysByPrefix = (prefixes) => {
  const keys = []
  try {
    for (let index = 0; index < localStorage.length; index += 1) {
      const key = localStorage.key(index)
      if (key && prefixes.some((prefix) => key.startsWith(prefix))) keys.push(key)
    }
    keys.forEach((key) => localStorage.removeItem(key))
    return keys.length
  } catch (error) {
    reportError(error, 'clear-prefix', prefixes.join(','))
    return 0
  }
}
